import { AppSettings } from "appSettings/appSettings.dev";
import { CountryArea } from "../types";
import { BaseService } from "./BaseService";

class PlacesService {
  private baseService: BaseService;
  constructor() {
    this.baseService = new BaseService(AppSettings.apiURL);
  }

  async GetCountriesAreas(): Promise<CountryArea[]> {
    const response = await this.baseService.get<CountryArea[]>(`Places/GetCountriesAreas`);
    return response?.data ?? [];
  }
}

export const placesService = new PlacesService();
